import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class Auth0SessionService {

  private authUrl = ApiEndpoints.authSession;
  constructor(private http: HttpClient) { }

  authorizeSession(imsCookieValue: string): Observable<any> {
    console.log('🚀 Calling Authorization Endpoint to generate HttpOnly cookie...');

    const payload = {
      ImsCookieValue: imsCookieValue
    };
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      withCredentials: true 
    };

    return this.http.post(this.authUrl, payload, httpOptions);
  }
}